import React, { Component } from 'react'
import Rate from 'rc-rate'

import './rc-rate.css'
import './feedback-types.css'

const STYLE = {
  fontSize: 26,
}

class FeedbackRate extends Component {
  render() {
    const { label, value, onChange } = this.props
    return (
      <div className="Feedback-question">
        <label className="Feedback-label">{label}</label>
        <Rate
          value={value}
          onChange={onChange}
          style={STYLE}
          character="&#9733;"
          unselectedCharacter="&#9734;"
        />
      </div>
    )
  }
}

export default FeedbackRate



// WEBPACK FOOTER //
// ./src/addons/feedback/types/Rate.js